import axios from "axios";
import config from "../config";

export function getCallRecordings(searchParams) {
  return axios.get(`${config.api_url}/call-recordings`, {
    params: searchParams,
  });
}

export function getCallRecordingTranscriptions(id = "", params) {
  return axios.get(`${config.api_url}/call-recording-transcriptions/${id}`, {
    params: params,
  });
}

export function transcribeCallRecording(data) {
  return axios.post(`${config.api_url}/call-recordings/transcribe`, data);
}

export function summariseCallRecording(data) {
  return axios.post(`${config.api_url}/call-recordings/summarise`, data);
}

export function getMinutesUsage() {
  return axios.get(`${config.api_url}/call-recordings/minutes-usage`);
}

export function summariseExistingTranscription(id, data) {
  return axios.post(
    `${config.api_url}/call-recording-transcriptions/${id}/summarise`,
    data,
  );
}

export function changeParticipantName(data) {
  return axios.patch(
    `${config.api_url}/call-recording-transcriptions/${data.sqid}/participant-name`,
    data,
  );
}

export function emailTranscription(id, data) {
  return axios.post(
    `${config.api_url}/call-recording-transcriptions/${id}/email`,
    data,
  );
}

export function queryTranscription(data) {
  return axios.post(
    `${config.api_url}/call-recording-transcriptions/${data.sqid}/query`,
    data,
  );
}
